import { CommissionConfig } from '@/types/commission';

/**
 * Global Commission Configurations
 * These can be moved to a database or API in the future
 */
export const COMMISSION_CONFIGS: Record<string, CommissionConfig> = {
    EVENT_ORGANIZER: {
        moduleId: 'EVENT_ORGANIZER',
        providerFeePercentage: 6,
        guestFeePercentage: 5,
        isActive: true,
    },
    FACILITY_BOOKING: {
        moduleId: 'FACILITY_BOOKING',
        providerFeePercentage: 5,
        guestFeePercentage: 8,
        isActive: true,
    },
};
